module.exports = __webpack_public_path__ + "img/type_POISON.db8a6abc.png";